import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapperHeaderTitle: {
        color: theme.palette.info.main,
        fontSize: "18px",
        fontWeight: 400,
        padding: "14px 32px 0 32px",
    },
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
    },
    barContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        paddingBottom: theme.spacing(3),
    },
    barWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    progressBarWidth: {
        width: "100%",
    },
    progressBarWithNameWidth: {
        width: "80%",
    },
    progressBar: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} 0 0`,

        "&> div:first-child": {
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
        },

        "&> div:last-child": {
            borderTopRightRadius: 50,
            borderBottomRightRadius: 50,
        },

        "&> div:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },
    progressBarSection: {
        height: 25,
        textAlign: "right",
    },
    connectedBar: {
        backgroundColor: theme.palette.success.main,
        position: "relative",
    },
    amountDisconnected: {
        position: "absolute",
        bottom: 30,
        right: 10,
        maxWidth: "120px",
        "&> h5": {
            fontSize: "12px !important",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    amountConnected: {
        position: "absolute",
        bottom: 30,
        left: 10,
        maxWidth: "120px",
        "&> h5": {
            fontSize: "12px !important",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    connectedIcon: {
        color: theme.palette.success.main,
    },
    disconnectedBar: {
        backgroundColor: theme.palette.warning.dark,
        position: "relative",
    },
    disconnectedIcon: {
        color: theme.palette.warning.dark,
    },
    referencesContainer: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
    },
    referenceItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: theme.spacing(4),
    },
    referenceIcon: {
        fontSize: "12px !important",
    },
    referenceTitle: {
        fontSize: "12px !important",
    },
    noData: {
        "&> div": {
            height: "76px !important",
        },
    },
}));
